export default __webpack_public_path__ + "static/media/pj-api-criptomoedas.85a7caa1.png";